import { Dispatch, SetStateAction, useEffect, useState } from "react";

import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Select, Drawer, Flex, Spin, Switch, Typography } from "antd";
import { useTranslation } from "react-i18next";

import { useAuth } from "auth/useAuth";
import { getUserRole } from "utils/authorizationUtils";

import {
  useGetLocationsLazyQuery,
  useGetClientsQuery,
  useGetClientQuery,
  useUpdateDistributionBoardSettingsMutation,
  useGetSettingsBoardQuery,
} from "../../graphql/main";

const LeftSideBar: React.FC<{
  isPortrait: boolean;
  isMobile: boolean;
  isLeftSideBarOpen: boolean;
  setIsLeftSideBarOpen: Dispatch<SetStateAction<boolean>>;
}> = ({ isPortrait, isMobile, isLeftSideBarOpen, setIsLeftSideBarOpen }) => {
  const { clientId, setClientId, setLocationId, locationId, role } = useAuth();
  const [isFirstDropDownOpen, setIsFirstDropDownOpen] = useState(false);
  const [isSecondDropDownOpen, setIsSecondDropDownOpen] = useState(false);
  const { setRole } = useAuth();
  const { t } = useTranslation();

  const { data: settingsData, refetch: refetchSettings } =
    useGetSettingsBoardQuery({
      pollInterval: 5000,
      variables: { locationId: locationId },
    });

  const [updateDistributionBoard] = useUpdateDistributionBoardSettingsMutation({
    onCompleted: () => refetchSettings(),
  });

  const { data: userData } = useGetClientQuery({
    onCompleted: () => {
      getUserRole() && setRole(getUserRole());
    },
  });
  const { data: clientsData } = useGetClientsQuery({
    onCompleted: (data) => {
      setClientId(data.clients[0]?.id);
    },
  });

  const [getLocations, { data: locationsData }] = useGetLocationsLazyQuery({
    onCompleted: (data) => {
      setLocationId(data?.locations[0]?.id);
    },
  });
  const sideBarCloseHandler = () => {
    setIsLeftSideBarOpen((prevState) => !prevState);
  };

  const locationChangeHandler = async (e: any) => {
    if (role === "Client") {
      setLocationId(e);
    } else {
      await getLocations({ variables: { clientId: e } });
      setClientId(e);
    }
  };

  const adminClientLocationChangeHandler = (e: string) => {
    setLocationId(e);
  };
  const drawerClickHandler = () => {
    isFirstDropDownOpen && setIsFirstDropDownOpen(false);
    isSecondDropDownOpen && setIsSecondDropDownOpen(false);
  };

  useEffect(() => {
    if (clientsData?.clients.length) {
      if (role === "Client") {
        getLocations({ variables: { clientId: userData?.client.clientId } });
      } else {
        getLocations({ variables: { clientId: clientsData?.clients[0].id } });
      }
    }
  }, [clientsData]);
  const selectedLocation = locationsData?.locations.find(
    (loc) => loc.id === locationId,
  );

  return (
    <Drawer
      headerStyle={{ borderBottom: "none" }}
      // closeIcon={!(isPortrait && isMobile)}
      size="default"
      width={300}
      // placement={isPortrait && isMobile ? "top" : "left"}
      placement="left"
      open={isLeftSideBarOpen}
      onClose={sideBarCloseHandler}
    >
      <Flex
        onClick={drawerClickHandler}
        vertical
        // align={"center"}
        justify={"center"}
      >
        {role && (clientsData || userData) ? (
          <Flex vertical>
            {role === "Client" ? (
              <label>{t("locations")}:</label>
            ) : (
              <label>{t("clients")}:</label>
            )}
            <Select
              onChange={(e) => locationChangeHandler(e)}
              id="location"
              style={{ marginTop: "0.5rem", width: "10rem" }}
              value={role === "Client" ? locationId : clientId}
            >
              {userData && role === "Client"
                ? locationsData?.locations?.map((elem) => {
                    return (
                      <Select.Option key={elem.id} id={elem.id} value={elem.id}>
                        {elem.name}
                      </Select.Option>
                    );
                  })
                : clientsData?.clients.map((elem) => {
                    return (
                      <Select.Option key={elem.id} id={elem.id} value={elem.id}>
                        {elem.name}
                      </Select.Option>
                    );
                  })}
            </Select>
          </Flex>
        ) : (
          <Spin />
        )}

        {role === "Admin" && (
          <Flex vertical style={{ marginTop: "1rem" }}>
            <label>{t("locations")}:</label>
            <Select
              style={{ marginTop: "0.5rem", width: "10rem" }}
              onChange={(e) => adminClientLocationChangeHandler(e)}
              id="locationAdmin"
              value={locationId}
            >
              {locationsData?.locations.map((elem) => {
                return (
                  <Select.Option key={elem.id} id={elem.id} value={elem.id}>
                    {elem.name}
                  </Select.Option>
                );
              })}
            </Select>
          </Flex>
        )}
        <Typography.Paragraph style={{ marginTop: "2rem" }}>
          {t("emergency_stop")}
        </Typography.Paragraph>
        <Flex>
          <Typography.Paragraph
            style={{ marginBottom: "1rem", marginRight: "0.5rem" }}
          >
            {t("pump_1")}
          </Typography.Paragraph>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={
              !settingsData?.distributionBoardSettings.emergencyStopPump1
            }
            onChange={(checked) => {
              updateDistributionBoard({
                variables: {
                  input: {
                    distributionBoardId: selectedLocation?.distributionBoardId,
                    emergencyStopPump1: !checked,
                  },
                },
              });
            }}
            style={{ marginBottom: "1rem", marginRight: "0.5rem" }}
          />
        </Flex>
        <Flex style={{ marginTop: "1rem" }}>
          <Typography.Paragraph>{t("pump_2")}</Typography.Paragraph>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={
              !settingsData?.distributionBoardSettings.emergencyStopPump2
            }
            onChange={(checked) => {
              updateDistributionBoard({
                variables: {
                  input: {
                    distributionBoardId: selectedLocation?.distributionBoardId,
                    emergencyStopPump2: !checked,
                  },
                },
              });
            }}
            style={{ marginBottom: "1rem", marginLeft: "0.5rem" }}
          />
        </Flex>
      </Flex>
    </Drawer>
  );
};

export default LeftSideBar;
